import { AuthService } from '../types';
import { getConfig } from '../utils';

import * as mock from './mockCognito';
import * as cognito from './cognito';

const isDevMode = getConfig('NODE_ENV') === 'development';
const useMockCognito = getConfig('REACT_APP_USE_MOCK_COGNITO') === 'true';

export default function getAuthModule(): AuthService {
  if (isDevMode && useMockCognito) {
    // tslint:disable:no-console
    console.warn('Mock cognito auth module loaded...');
    return mock;
  }
  return cognito;
}

export * from './common';



// WEBPACK FOOTER //
// ./src/auth/index.ts